import { getElementOrLogError } from '../../utils/utils';
export class Contacts {
    constructor(template, events) {
        this.events = events;
        this.form = getElementOrLogError('.form', template.content).cloneNode(true);
        this.inputs = Array.from(this.form.querySelectorAll('.form__input'));
        this.submitButton = getElementOrLogError('.button', this.form);
        this.errorMessages = getElementOrLogError('.form__errors', this.form);
        this.attachInputListeners();
        this.attachFormSubmitListener();
    }
    set isValid(value) {
        this.submitButton.disabled = !value;
    }
    render() {
        return this.form;
    }
    attachInputListeners() {
        this.inputs.forEach(input => {
            input.addEventListener('input', (event) => {
                const target = event.target;
                const fieldName = target.name;
                const fieldValue = target.value;
                this.events.emit('contacts:inputChange', { field: fieldName, value: fieldValue });
            });
        });
    }
    attachFormSubmitListener() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.events.emit('renderSuccessWindow:open');
        });
    }
}
